import React, { useEffect, useState } from "react";

import { colors } from "@zapalacorp/tokens";

import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import classnames from "classnames";
import { DefaultTooltip } from "Components/Generic/Tooltip";
type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
  style?: React.CSSProperties;
};

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy, style } = props;
  const clasz = badgeTextCSS();
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);

  useEffect(() => {
    if (value) {
      const hasEllipsis = value.length > 20;

      setIsTooltipVisible(hasEllipsis);
    }
  }, []);

  return (
    <div className={classnames(clasz.badgeAlign, classes.customBadge, className)} style={style}>
      {isTooltipVisible ? (
        <DefaultTooltip title={value || ""} placement="top-start">
          <span className={classes.textValue} data-cy={dataCy}>
            {value}
          </span>
        </DefaultTooltip>
      ) : (
        <span className={classes.textValue} data-cy={dataCy}>
          {value}
        </span>
      )}
    </div>
  );
};

const styles = () => ({
  customBadge: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
      props?.backgroundColor,
    minWidth: "51px",
    padding: "4px 12px",
    borderRadius: "20px",
    maxWidth: "148px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    cursor: "default",
    width: "fit-content",
  },
  textValue: {
    color: (props: { textColor?: string }) => props?.textColor,
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    lineHeight: "20px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "148px",
    width: "fit-content",
  },
});

const badgeTextCSS = makeStyles(() => ({
  badgeAlign: {
    textAlign: "center",
    display: "block",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "148px",
    width: "fit-content",
  },
}));
const StyledBadge = withStyles(styles)(SimpleBadge);
export const BadgeJobStatusComponent = (props: Props) => {
  const { value, className, dataCy, style } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
          style={style}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase?.()) {
    case "booked":
      return renderBadge("#eafaf9", "#38CFC4", value);
    case "received":
      return renderBadge("#e7e9fd", "#7E8AF6", value);
    case "packed":
      return renderBadge("#F4EBFF", "#7F56D9", value);
    case "started":
      return renderBadge("#dfe6ec", "#93A9BD", value);
    case "loaded":
    case "partly loaded":
      return renderBadge("#dbf0e1", "#50B56C", value);
    case "unloaded":
      return renderBadge("#ffede6", "#FFAA86", value);
    case "late":
      return renderBadge("#faebeb", "#CF4842", value);
    case "delivered":
      return renderBadge("#eaf5fa", "#38A2CF", value);
    case "finished":
      return renderBadge("#fcf8e9", "#E5CA4F", value);
    case "in transit":
      return renderBadge("#faf1ea", "#CF7738", value);
    case "in progress":
      return renderBadge("#faf1ea", "#CF7738", value);
    case "cancelled":
      return renderBadge("#faebeb", "#CF4842", value);
    case "planned":
      return renderBadge("#eaf5fa", "#308CDB", value);
    case "transshipped":
      return renderBadge("#E0F2FE", "#0086C9", value);
    case "placeholder":
      return renderBadge(colors.blue50, colors.blue600, value);
    default:
      return renderBadge("#eafaf9", "#38CFC4", value);
  }
};

export const BadgeTypeComponent = (props: Props) => {
  const { value, classes } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          classes={classes}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case "import":
      return renderBadge("#e7effd", "#5D92F4", value);
    case "export":
      return renderBadge("#fdf0e7", "#F18E47", value);
    case "storage":
      return renderBadge("#d1d4e0", "#464D69", value);
    case "toll":
      return renderBadge("#e7effd", "#5D92F4", value);
    case "fine art":
      return renderBadge("#fff9e6", "#ffc000", value);
    case "business service":
      return renderBadge("#ffe6f2", "#FF69B4", value);
    case "interstate jobs":
      return renderBadge("#d1d4e0", "#464D69", value);
    case "interstate":
      return renderBadge("#d1d4e0", "#464D69", value);
    case "local":
      return renderBadge("#e8e7fd", "#8683F6", value);
    case "country removal":
      return renderBadge("#e6ffe8", "#00D014", value);
    case "long distance":
      return renderBadge("#cccccc", "#727272", value);
    case "store out":
      return renderBadge("#d1d4e0", "#464D69", value);
    default:
      return renderBadge("#d1d4e0", "#464D69", value);
  }
};
